/**
 * API client for admin endpoints
 */

import { apiClient } from './client';
import { buildApiUrl } from './config';
import type { AdminUsersStatsResponse } from '../types/admin';

/**
 * Fetch aggregated statistics for all users.
 * Requires admin access (email in ADMIN_EMAILS whitelist).
 */
export async function fetchAdminUsersStats(): Promise<AdminUsersStatsResponse> {
  const url = buildApiUrl('/api/admin/users-stats');

  const response = await apiClient(url, {
    method: 'GET',
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: response.statusText }));
    throw new Error(error.detail || `HTTP ${response.status}: ${response.statusText}`);
  }

  return response.json();
}
